export const gridWrapper = 'pb-10 xl:grid-cols-3 lg:px-44 md:pt-[108px]'
export const contactBox = 'flex flex-col p-8'
export const imageWrapper = 'w-10 pb-3 md:pb-4'
export const linkWrapper = 'pb-4'
export const linkStyles = 'font-Roboto font-medium'
export const textWrapper = 'w-fit flex-wrap pb-10 text-justify'
export const textStyles = 'text-14 tracking-0 leading-20 w-full'
